import { GraphQLQuery } from '@settings/services/graphQLClient/GraphQLClient';
import gql from 'graphql-tag';

import { HistoryItem } from './loadUserQuery';

export interface LoadBitrixUserHistoryQueryResponse {
  BitrixUserProfile: {
    id: string;
    history: HistoryItem[] | null;
  };
}

/**
 * Запрос загрузки истории поиска пользователя
 */
export class LoadBitrixUserHistoryQuery implements GraphQLQuery<null> {
  readonly query: any;

  readonly variables: null;

  readonly isSilent = true;

  constructor() {
    this.variables = null;
    this.query = gql`
      query __LOAD_USER_HISTORY__ {
        BitrixUserProfile {
          id
          history {
            bitrix_user_id
            created_at
            id
            request_parameters
            short_link
            type_calculation
          }
        }
      }
    `;
  }
}
